import { SET_MESSAGE, CLEAR_MESSAGE, SET_RESPONSE, CLEAR_RESPONSE, SET_TOKEN, CLEAR_TOKEN } from "../Actions/types";

const initialState = {};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SET_MESSAGE:
      return { message: payload };

    case CLEAR_MESSAGE:
      return { message: "" };

    case SET_RESPONSE:
      return { response: payload };

    case CLEAR_RESPONSE:
      return { response: "" };

    case SET_TOKEN:
      return { token: payload };

    case CLEAR_TOKEN:
      return { token: "" };

    default:
      return state;
  }
}